// https://vuex.vuejs.org/en/mutations.html

export default {
  refreshVendors (state, vendors) {
    state.list = vendors
  },
}
